import type * as Y from 'yjs';

/**
 * Board quotas (spec « Quotas applicatifs », P12a): performance and comfort limits checked by the local commands only.
 * A peer's update, an undo or a restored version is never refused: a room that rejected updates its sender already
 * applied would break convergence, and a client that bypasses the check only slows a board it may already edit.
 */
export const BOARD_LIMITS = { objects: 5_000, images: 300 } as const;
/** Past these the editor says the board is getting heavy. */
export const BOARD_WARNINGS = { objects: 3_000, images: 250 } as const;

export type LimitKind = keyof typeof BOARD_LIMITS;
export type BoardCounts = { objects: number; images: number };

/** Every object of every page (valid or not: each costs a map), and the image objects among them. */
export function boardCounts(objects: Y.Map<Y.Map<unknown>>): BoardCounts {
  let images = 0;
  for (const m of objects.values()) if (m.get('type') === 'image') images++;
  return { objects: objects.size, images };
}

/** The limit adding `adds` to `now` would pass (objects first), or null when it fits. */
export function overLimit(now: BoardCounts, adds: BoardCounts): LimitKind | null {
  if (now.objects + adds.objects > BOARD_LIMITS.objects) return 'objects';
  if (adds.images > 0 && now.images + adds.images > BOARD_LIMITS.images) return 'images';
  return null;
}
